<template lang="html">
  <section class="form-box">
     <div class="container">
       <div class="row">
         <h2 class="urlap-title">Javasolt határidő</h2>
       </div>
       <div class="row">
         <div class="color-primary big">
           <b>{{hatarido}}</b>
         </div>
       </div>
    </div>
  </section>
</template>
<script>
export default {
  props: [
    'hatarido'
  ]
}
</script>
<style lang="css" scoped>
</style>
